import { render, staticRenderFns } from "./questionsManager.vue?vue&type=template&id=41df4284&scoped=true"
import script from "./questionsManager.vue?vue&type=script&lang=js"
export * from "./questionsManager.vue?vue&type=script&lang=js"
import style0 from "./questionsManager.vue?vue&type=style&index=0&id=41df4284&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41df4284",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41df4284')) {
      api.createRecord('41df4284', component.options)
    } else {
      api.reload('41df4284', component.options)
    }
    module.hot.accept("./questionsManager.vue?vue&type=template&id=41df4284&scoped=true", function () {
      api.rerender('41df4284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/questionsManager.vue"
export default component.exports